/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuestionnaireEvaluateRequestAnswer
 */
export interface QuestionnaireEvaluateRequestAnswer {
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireEvaluateRequestAnswer
     */
    questionId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestionnaireEvaluateRequestAnswer
     */
    answers: Array<string>;
}

/**
 * Check if a given object implements the QuestionnaireEvaluateRequestAnswer interface.
 */
export function instanceOfQuestionnaireEvaluateRequestAnswer(value: object): value is QuestionnaireEvaluateRequestAnswer {
    if (!('questionId' in value) || value['questionId'] === undefined) return false;
    if (!('answers' in value) || value['answers'] === undefined) return false;
    return true;
}

export function QuestionnaireEvaluateRequestAnswerFromJSON(json: any): QuestionnaireEvaluateRequestAnswer {
    return QuestionnaireEvaluateRequestAnswerFromJSONTyped(json, false);
}

export function QuestionnaireEvaluateRequestAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionnaireEvaluateRequestAnswer {
    if (json == null) {
        return json;
    }
    return {
        
        'questionId': json['questionId'],
        'answers': json['answers'],
    };
}

export function QuestionnaireEvaluateRequestAnswerToJSON(json: any): QuestionnaireEvaluateRequestAnswer {
    return QuestionnaireEvaluateRequestAnswerToJSONTyped(json, false);
}

export function QuestionnaireEvaluateRequestAnswerToJSONTyped(value?: QuestionnaireEvaluateRequestAnswer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'questionId': value['questionId'],
        'answers': value['answers'],
    };
}

